import * as React from 'react';
import GamePageLayout from '../../components/GamePageLayout';
import Footer from '../../components/Footer/Footer';
import {HOME_ACTION_PERSIST,HOME_ACTION_CLEAR} from "../../redux/Home/home.constant";
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import GameNavbar from "../../components/GameNavbar";
import GameHeader from "../../components/GameHeader";
import appService from '../../Service'
import {Button,Util} from "baziigram";
import './styles.css'
import {useEffect, useState} from "react";
import {dictionary} from "../../constants"
import gameanalytics from "gameanalytics";

const NewsPage = () => {

    React.useEffect(()=>{
        loadNews()

    },[])



    const [news,setNews] = useState(null)
    const [serverError,setServerError] = useState(null)
    const [ghostIndex,setGhostIndex] = useState(0)
    const [language , setLanguage] = React.useState("en")
    const [className , setClassName] = React.useState("ltr text-left")

        React.useEffect(()=>{
        setLanguage(Util.getLanguage())
         if(language == "fa")
         setClassName("rtl text-right")
        },[language])

    const animations=["float","dandelion-move-right","dandelion-move-left"]

    const loadNews=()=>{
        setServerError(null)
        appService.GetNews().then(res=>{
           setNews(res.news)
             }).catch(err=>{
            setServerError(dictionary.retryText[language])
        })
    }


    const moveGhost=(event)=>{
        setGhostIndex(ghostIndex==2?0:ghostIndex+1)
        event.target.style.animationName=animations[ghostIndex]
    }

    const scrollToNews = ()=>{
        document.getElementById('news').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }

  const goToLink=(link)=>{
        if(link!=null && link !="")
       window.open(link)
  }


    return (
        <GamePageLayout type={HOME_ACTION_CLEAR}>
            <GameNavbar />
            <div className={"rtl"}>
                <GameHeader class={"d-flex  home-header"}>

                        <div className={"text_header text-center d-flex flex-column justify-content-center align-items-center"}>
                            <div dangerouslySetInnerHTML={{__html: dictionary.newsHeader[language]}} />
                            <Button className="mt-2" onClick={scrollToNews} title={dictionary.seeNews[language]}></Button>

                        </div>

                </GameHeader>


                <div id={"news"} className='main_container'>
                    {/* <div className="main_container"> */}

                    {news==null && serverError==null && <div
                        className={`baziigram-spinner mt-5 spinner-border text-light m-auto`}
                        role="status"
                    ></div>}
                    {serverError && <div className={"text-center text-warning "}>
                        {serverError}
                        <Button onClick={loadNews} className={"mt-3"} title={dictionary.retry[language]}/>
                    </div>}
                    {news != null && serverError==null && <>


                        <div className="grid-container rtl">
                            <div
                                className={`row align-items-start justify-content-center`}
                                style={{ rowGap: '50px', paddingTop: '50px' }}
                            >
                                {
                                    news && news.map(item=>{
                                        return <div  onClick={()=>goToLink(item.link)} className="col-12 col-lg-8  my-4">
                                            <div  className={"news-item d-flex flex-column align-items-center flex-wrap"}>
                                          <div className={`${className} d-flex flex-row justify-content-between align-items-center`}>
                                            <div className={`${className} text-warning my-2`}>{item.title}</div>
                                                <div className={`${className} my-2`}>{item.date}</div>
                                            </div>
                                                <div className={`${className}  my-2`}>{item.description}</div>

                                            </div>
                                        </div>
                                    })
                                }

                            </div>

                        </div>
                    </>}


                </div>


            </div>

        </GamePageLayout>
    )
}

export default NewsPage;
